import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  profile: {},
  consultationDetails: {},
  medicines: [],
  labTests: [],
  review: {},
};

const consultationSlice = createSlice({
  name: 'consultation',
  initialState,
  reducers: {
    setProfile(state, action) {
      state.profile = action.payload;
    },
    setConsultationDetails(state, action) {
      state.consultationDetails = action.payload;
    },
    setMedicines(state, action) {
      state.medicines = action.payload;
    },
    setLabTests(state, action) {
      state.labTests = action.payload;
    },
    setReview(state, action) {
      state.review = action.payload;
    },
  },
});

export const {
  setProfile,
  setConsultationDetails,
  setMedicines,
  setLabTests,
  setReview,
} = consultationSlice.actions;

export default consultationSlice.reducer;
